import React from "react";
import styled from "styled-components";
import TerritoryDataHeader from "../TerritoryDataHeader/TerritoryDataHeader";
import StoreMetricsCard from "../StoreMetricsCard/StoreMetricsCard";

export interface StoreData {
  id: string;
  storeName: string;
  caN: number; // Current Revenue (e.g., 129021)
  caN1: number; // Previous Revenue (e.g., 126021)
  clientsN: number; // Current Clients (e.g., 10384)
  progClients: number; // Client Growth % (e.g., 2.75)
  progPrev: number; // Forecast Progression % (e.g., 12.40)
  quotePart: number; // Market Share % (e.g., 7.75)
}

export interface TerritoryData {
  id: string;
  territoryName: string; // e.g., "DTI IDF Ouest"
  storeCount: number; // e.g., 4
  overallTrend: number; // e.g., 3.7
  caN: number; // Total Revenue (e.g., 14220540)
  progCa: number; // Revenue Progression % (e.g., 5.80)
  ecartBudget: number; // Budget Variance % (e.g., 105)
  stores: StoreData[]; // List of stores belonging to this territory
}

interface MobileTerritoryDetailProps {
  territory: TerritoryData;
  onBack: () => void;
}

export const MobileTerritoryDetail: React.FC<MobileTerritoryDetailProps> = ({
  territory,
  onBack,
}) => {
  return (
    <Container>
      <StickyHeaderContainer>
        <TerritoryDataHeader data={territory} onBack={onBack} />
      </StickyHeaderContainer>
      <StoresStackContainer>
        {territory.stores.map((store) => (
          <StoreCardWrapper key={store.id}>
            <StoreMetricsCard store={store} />
          </StoreCardWrapper>
        ))}
      </StoresStackContainer>
    </Container>
  );
};

export default MobileTerritoryDetail;

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  background-color: #f8fafc;
  min-height: 100vh;
`;

const StickyHeaderContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  width: 100%;
`;

const StoresStackContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const StoreCardWrapper = styled.div`
  width: 100%;
`;
